import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
};

export default function RHFTextField({ name, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField sx={{ border: '1px solid #dd0000', borderRadius: 1, color: '#000 !important', backgroundColor: '#fff'}} {...field} fullWidth error={!!error} helperText={error?.message} {...other} onWheel={(e) => e.target.blur()} />
      )}
    />
  );
}
